<template>
  <div class="enrolling-statistics-common">
    <div class="header">
      <slot name="header">
        <div class="title">{{title}}</div>
        <div class="export">
          <el-button @click="exportData" type="primary"><i class="iconfont icon-daochu"></i>导出数据</el-button>
        </div>
      </slot>
    </div>
    <div class="body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnrollingStatisticsCommon',
  props: {
    title: String,
    exportData: Function
  }
}
</script>

<style lang="scss">
.enrolling-statistics-common {
  & > .header {
    padding: 18px 20px;
    border-bottom: 1px solid #EBEEF5;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  & > .body {
    padding: 20px;
  }
}
</style>
